module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1530-ad3700fa6750863b703689318dd7dedf.png";